<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Usuário</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="users.name"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Email">
                        <span class="required">*</span> Email:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="users.email" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="Cellphone">Celular:</label>
                      <input autocomplete="new-password" class="form-control" id="Cellphone" type="text"
                        v-mask="'(99) 99999-9999'" v-model="users.cellphone" placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label>CPF:</label>
                      <input type="text" v-mask="'999.999.999-99'" class="form-control" v-model="users.cpf"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label>RG:</label>
                      <input type="text" v-mask="'99.999.999-9'" class="form-control" v-model="users.rg"
                        placeholder="" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="inputUser">
                        <span class="required">*</span> Nível de acesso:
                      </label>
                      <select v-model="users.access_nivel" class="form-control">
                        <option :value="1" :key="1">Usuário Padrão</option>
                        <option :value="2" :key="2">Gestor Empresa</option>
                        <option v-if="
                          $store.state.user.perfil_id == 6 ||
                          $store.state.user.perfil_id == 7 ||
                          $store.state.user.perfil_id == 8
                        " :value="6" :key="6">
                          Administrador TI
                        </option>
                        <option v-if="
                          $store.state.user.perfil_id == 6 ||
                          $store.state.user.perfil_id == 7 ||
                          $store.state.user.perfil_id == 8
                        " :value="7" :key="7">
                          Administrador RH
                        </option>
                        <option v-if="
                          $store.state.user.perfil_id == 6 ||
                          $store.state.user.perfil_id == 7 ||
                          $store.state.user.perfil_id == 8
                        " :value="8" :key="8">
                          Administrador Geral
                        </option>
                        <option :value="10" :key="10">Usuário Cliente</option>
                      </select>
                    </div>
                  </div>
                  <div class="row" v-if="$route.params.id">
                    <div class="col-md-12 mb-2">
                      <button type="button" class="btn btn-add" @click="toggleFormSenha">
                        <i class="fas fa-key"></i> Alterar Senha
                      </button>
                    </div>
                  </div>
                  <div class="form-row" v-if="change_password">
                    <div class="form-group col-md-6">
                      <label for="password">
                        <span class="required">*</span> Senha:
                      </label>
                      <input autocomplete="new-password" type="password" id="password" class="form-control"
                        v-model="users.password" placeholder="" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="confirmPassword">
                        <span class="required">*</span> Confirme a senha:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="confirmPassword" placeholder=""
                        type="password" v-model="users.password_confirmation" />
                    </div>
                  </div>

                  <div class="col-md-12 mt-1 row">
                    <div class="col-md-12 text-center">
                      <h4>Desenhe sua assinatura abaixo</h4>
                    </div>
                    <div class="col-md-12 d-flex justify-content-center">
                      <canvas id="canvas" ref="canvas" style="border: 1px solid #000" width="700" height="200"
                        @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
                        @mouseleave="stopDrawing"></canvas>
                    </div>
                    <div class="col-md-12 mt-1 d-flex justify-content-center">
                      <button type="button" class="btn btn-delete" @click="clearSignature">
                        Limpar Assinatura
                      </button>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="userPic"> Foto do Perfil </label>
                    <input type="file" accept="image/*" class="form-control" id="userPic" @change="uploadImage">
                    <div class="user-img">
                      <img v-if="previewImage" :src="previewImage" class="photo" />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      change_password: true,
      users: {
        name: "",
        email: "",
        cellphone: "",
        cpf: "",
        rg: "",
        access_nivel: "",
        password: "",
        password_confirmation: "",
      },
      previewImage: null,

      // Assinatura: so vai pro back se o usuario mexeu no canvas nesta tela
      ctx: null,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      hasSignature: false,
      signatureChanged: false,
    };
  },
  methods: {
    toggleFormSenha() {
      this.change_password = !this.change_password;
    },
    makeFormData() {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name || "");
      fd.append("email", self.users.email || "");
      fd.append("password", self.users.password || "");
      fd.append("password_confirmation", self.users.password_confirmation || "");
      fd.append("cpf", self.users.cpf || "");
      fd.append("rg", self.users.rg || "");
      fd.append("cellphone", self.users.cellphone || "");
      fd.append("access_nivel", self.users.access_nivel || "");
      fd.append("photo", photo && photo.files[0] ? photo.files[0] : "");

      if (self.signatureChanged) {
        if (self.hasSignature) {
          fd.append("signature", self.$refs.canvas.toDataURL("image/png"));
        } else {
          fd.append("remove_signature", 1);
        }
      }

      // Apenas se for edição
      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      } else {
        fd.append("_method", "POST");
      }

      return fd;
    },
    save() {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    getUsers(id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      axios
        .get(api)
        .then((response) => {
          const user = response.data.data[0];

          self.users = { ...user, password: "", password_confirmation: "" };
          self.previewImage = user.photo || null;
          self.change_password = false;

          self.loadSignature(user.signature);
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    loadSignature(url) {
      const self = this;

      self.ctx.clearRect(0, 0, 700, 200);
      self.hasSignature = false;
      self.signatureChanged = false;

      if (!url) return;

      const image = new Image();
      // Sem crossOrigin o canvas fica "tainted" (a API roda em outra origem)
      // e o toDataURL() do save estoura SecurityError ao redesenhar.
      image.crossOrigin = "anonymous";
      image.onload = function () {
        self.ctx.drawImage(image, 0, 0, 700, 200);
        self.hasSignature = true;
      };
      image.src = url + "?t=" + Date.now();
    },
    uploadImage(e) {
      const image = e.target.files[0];
      if (!image) return;

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (ev) => {
        this.previewImage = ev.target.result;
      };
    },
    startDrawing(event) {
      this.isDrawing = true;
      const { offsetX, offsetY } = event;
      this.lastX = offsetX;
      this.lastY = offsetY;
    },
    draw(event) {
      if (!this.isDrawing) return;
      const { offsetX, offsetY } = event;
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(offsetX, offsetY);
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 1;
      this.ctx.stroke();
      this.lastX = offsetX;
      this.lastY = offsetY;
      this.hasSignature = true;
      this.signatureChanged = true;
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    clearSignature() {
      this.ctx.clearRect(0, 0, 700, 200);
      this.hasSignature = false;
      this.signatureChanged = true;
    },
  },
  mounted() {
    this.ctx = this.$refs.canvas.getContext("2d");

    let id = this.$route.params.id;
    if (id) {
      this.change_password = false;
      this.getUsers(id);
    }
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>